import * as React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import type { UiBaseProps } from "../uiProps.utils";

export type SelectOptionProps = UiBaseProps & {
  value: string | number;
  disabled?: boolean;
};

// The dropdown hands each option its selected state and click handler, and needs a ref to place the menu.
export const SelectOption = React.forwardRef<HTMLLIElement, SelectOptionProps>(function SelectOption(props, ref) {
  return <MenuItem ref={ref} {...(props as any)} />;
});
